var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#303030",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.857 0H5.714c-.63 0-1.143.512-1.143 1.143s.512 1.143 1.143 1.143h6.384L.335 14.049c-.447.446-.447 1.17 0 1.616.223.223.515.335.808.335.292 0 .585-.112.808-.335L13.714 3.902v6.384c0 .63.512 1.143 1.143 1.143S16 10.917 16 10.286V1.143C16 .512 15.488 0 14.857 0z",
    transform: "translate(-48 -214) translate(48 214) translate(4 4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-48 -214) translate(48 214)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgZmlsbD0iIzMwMzAzMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQuODU3IDBINS43MTRjLS42MyAwLTEuMTQzLjUxMi0xLjE0MyAxLjE0M3MuNTEyIDEuMTQzIDEuMTQzIDEuMTQzaDYuMzg0TC4zMzUgMTQuMDQ5Yy0uNDQ3LjQ0Ni0uNDQ3IDEuMTcgMCAxLjYxNi4yMjMuMjIzLjUxNS4zMzUuODA4LjMzNS4yOTIgMCAuNTg1LS4xMTIuODA4LS4zMzVMMTMuNzE0IDMuOTAydjYuMzg0YzAgLjYzLjUxMiAxLjE0MyAxLjE0MyAxLjE0M1MxNiAxMC45MTcgMTYgMTAuMjg2VjEuMTQzQzE2IC41MTIgMTUuNDg4IDAgMTQuODU3IDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDggLTIxNCkgdHJhbnNsYXRlKDQ4IDIxNCkgdHJhbnNsYXRlKDQgNCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBIMjRWMjRIMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OCAtMjE0KSB0cmFuc2xhdGUoNDggMjE0KSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };